import React from 'react'
import { IconButton, makeStyles } from '@material-ui/core'
import Tooltip from '@material-ui/core/Tooltip'
import RefreshIcon from 'mdi-material-ui/Sync'
import memoizeOne from 'memoize-one'
import { MUIDataTableColumnDef } from 'mui-datatables'

import { t } from '../../../../i18n'
import DataTable from '../../../../components/DataTable'
import { CustomerStockData } from '../../../../services/customerStockService'

const useStyles = makeStyles(() => ({
  iconBtn: {
    padding: 4,
  },
}))

interface Props {
  customerStockData: CustomerStockData[]
  columns: MUIDataTableColumnDef[]
  tableDataMapper: (
    customerStockData: CustomerStockData
  ) => Array<string | number | CustomerStockData>
  refresh?: () => void
  title: string
}

export const ControllerDataCustomerStockList = ({
  customerStockData,
  columns,
  tableDataMapper,
  refresh,
  title,
}: Props) => {
  const classes = useStyles()

  const dataTableOptions = {
    download: true,
    downloadOptions: {
      filename: 'customer_stock.csv',
      separator: ';',
      filterOptions: {
        useDisplayedRowsOnly: true,
      },
    },
    customToolbar: () => {
      if (refresh) {
        return (
          <Tooltip title={t('Rafraîchir les données')}>
            <IconButton
              color="default"
              className={classes.iconBtn}
              onClick={refresh}
            >
              <RefreshIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )
      }
      return
    },
  }

  const customerStockToTableData = memoizeOne(
    (customerStockData: CustomerStockData[]) =>
      customerStockData.map(data => tableDataMapper(data).concat(data))
  )

  return (
    <DataTable
      columns={columns}
      title={title}
      data={customerStockToTableData(customerStockData)}
      emptyContent={t('Aucune donnée')}
      options={dataTableOptions}
    />
  )
}

export default ControllerDataCustomerStockList
